import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { OnboardingService } from '../anonymous/api/account/services/onboarding.service';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { SecurityService } from './security.service';

@Injectable({
  providedIn: 'root'
})
export class SecureGuard implements CanActivate {
  constructor(public router: Router,
    private onboardingService: OnboardingService,
    private securityService: SecurityService) { }

  onboardingStatus: number = 0;

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    let onboarding$ = this.onboardingService.checkOnboarding().pipe(
      map(res => {
        let mustOnboard = res.mustOnboard?.toString() === 'true';
        if (mustOnboard) {
          this.onboardingStatus = res?.onboardingStatus?.id
          switch (this.onboardingStatus) {
            case 1:
              if (route.url[0].path !== 'steps')
                this.router.navigate(['/onboarding']);
              break;
            case 2:
              this.router.navigate(['/onboarding/review-contract']);
              break;
            case 3:
              this.router.navigate(['/onboarding/review-contract']);
              break;
            case 4:
              this.router.navigate(['/onboarding/thanks-for-sign']);
              break;
            case 5:
              this.router.navigate(['/onboarding/thanks-for-sign']);
              break;
            case 6:
              this.router.navigate(['/secure/']);
              break;
            case 7:
              this.router.navigate(['/onboarding/steps']);
              break;
          }
        }
        else {
          if (route.url[0].path !== 'secure')
            this.router.navigate(['/secure']);
        }
        return !mustOnboard;
      }),
      catchError(error => {
        return of(false);
      })
    );

    return onboarding$;
  }
}
